import React from "react";
import Auth from "./auth";

const Context = (props) => {
  return <Auth>{props?.children}</Auth>;
};

export default Context;
